import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetPrevisioniComponent } from './widget-previsioni.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [WidgetPrevisioniComponent],
  imports: [
    CommonModule,
    NgbModule,
  ],
  exports: [WidgetPrevisioniComponent] 
})
export class WidgetPrevisioniModule { }
